import { render, staticRenderFns } from "./AccessLevelActionsSelector.vue?vue&type=template&id=566deb4e&scoped=true&"
import script from "./AccessLevelActionsSelector.vue?vue&type=script&lang=js&"
export * from "./AccessLevelActionsSelector.vue?vue&type=script&lang=js&"
import style0 from "./AccessLevelActionsSelector.vue?vue&type=style&index=0&id=566deb4e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566deb4e",
  null
  
)

export default component.exports